import { createContext, useEffect, useRef, useState } from 'react'

export const ToastContext = createContext<HTMLDivElement | null>(null)

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [ref, setRef] = useState<HTMLDivElement | null>(null)
  const toastContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setRef(toastContainerRef.current)
  }, [toastContainerRef])

  return (
    <>
      <ToastContext.Provider value={ref}>{children}</ToastContext.Provider>
      <div className="z-10" ref={toastContainerRef} />
    </>
  )
}

export default ToastProvider
